import "./Home_Styles/Image_box_second.css";

const Image_box_second = () => {
    return (
        <div className="Home_image_box_2">
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/7b2e305484a-DevicesClearanceStore.jpg?dim=1440x0" alt="" /></div>
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/0fa23978f05-Omez.jpg?dim=1440x0" alt="" /></div>
            <div><img src="https://cdn01.pharmeasy.in/dam/banner/banner/6f91440bbe5-Zedex.jpg?dim=1440x0" alt="" /></div>
        </div>
    );
};

export {Image_box_second};